module.exports = __webpack_public_path__ + "img/greece.2fc82384.svg";